import React from 'react'

export const IconCorrectTitleAlert = () => <ion-icon name="checkmark-outline"></ion-icon>
